<div class="bg-white mt-40 mb-25 p-25 w-60 w-100-sm b-s1-00012 brds-4px d-flex-col ff-robot m-auto">
    <div class="d-block w-100 ta-center">
        <mat-icon class="text-FF8F00">error</mat-icon>
    </div>
    <p class="fs-20 fw-500 lh-24 text-FF8F00 ta-center mt-15-i">Could not Place Your Order</p>
</div>